export class ContactData {

    /**
     * ContactData constructor.
     *
     * @param {string} mediatorCode
     * @param {string} nameContact
     * @param {string} nifContact
     * @param {string} tlfEmailContact
     */
    constructor(mediatorCode, nameContact, nifContact, tlfEmailContact) {
        this.mediatorCode = mediatorCode;
        this.nameContact = nameContact;
        this.nifContact = nifContact;
        this.tlfEmailContact = tlfEmailContact;
    }

}


export class MediatorSubmitter {

    /**
     * MediatorSubmitter contructor.
     *
     * @param {ContactData} contactData
     */
    constructor(contactData) {
        this.contactData = contactData;
    }

    /**
     * Submit the mediator contact data
     *
     * @return {Promise<void>}
     */
    async submit() {
        const requestBody = JSON.stringify(this.contactData);
        console.log(requestBody);
        const response = await fetch("https://www.generali.es/dva_commonWebServices/rest/mediatorContact", {
            method: "POST",
            mode: "cors",
            headers: {
                "Content-Type": "application/json"
            },
            body: requestBody
        });

        const responseData = await response.json();
        console.log(responseData);
        if (typeof responseData["statusOK"] !== "undefined" && responseData["statusOK"] !== true) {
            throw new Error(`The request on form submit has return an error: ${responseData['errorMessage']}`);
        }
    }

}